export default __webpack_public_path__ + "static/media/logo_full.87c73c5f.png";